import { Component, Inject, Input, OnInit } from '@angular/core';
import { ReservationStayPreferences } from '../../api/model/reservation/stay-preferences/reservation-stay-preferences.model';
// import * as mockData from '../../api/model/reservation/stay-preferences/stay-preferences-mock1.json';
import { AppAction } from '../../store/interfaces/IAppState';
import { CancelReservationDelegate, ModifyReservationDelegate, ModifyAccountDelegate, } from '../../api/delegates';
import { APP_CONFIG } from '../../api/config';
import { Router } from '@angular/router';
import { Unsubscribe } from 'redux';
import { useDefault } from '../../common/common';
import { ActionHandler } from '../../store/action.handler';
import { NgRedux } from '@angular-redux/store';
import { Actions, IAppConfig, IAppState } from '../../store';
import { Reservation } from '../../api/model/reservation/reservation.model';
import { Hotel } from '../../api/model/hotel/hotel.model';
import { RouteNames } from '../../api/enums';

@Component({
  selector: 'stay-mgmt-stay-preference',
  templateUrl: './stay-preference.component.html',
  styleUrls: ['./stay-preference.component.scss']
})
export class StayPreferenceComponent implements OnInit {
  @Input() stayPreferences: ReservationStayPreferences;
  @Input() isOpen: boolean;
  @Input() messages: { [key: string]: string };
  @Input() disableForm: boolean;

  error: any = null;
  saveToProfile: boolean;
  category: string;
  themeSVGStroke: boolean;
  unsubscribe: Unsubscribe;
  state: IAppState;
  reservation: Reservation = null;
  reservationId: string;
  lastName: string;
  hotel: Hotel = null;
  openContainer: number;
  router: Router;
  debounceTime: number;
  shouldDisplay: boolean;

  constructor(
    @Inject(APP_CONFIG) protected appConfig: IAppConfig,
    private _ngRedux: NgRedux<IAppState>,
    private _modifyReservationDelegate: ModifyReservationDelegate,
    private _modifyAccountDelegate: ModifyAccountDelegate,
    private _cancelRes: CancelReservationDelegate,
    private _actions: Actions,
    private _router: Router
  ) {
    this.openContainer = -1;
    this.debounceTime = 0;
  }

  ngOnInit() {
    this.themeSVGStroke = true;
    this.category = 'Rooms and Rates';
    this.updateFromState();
    this.unsubscribe = this._ngRedux.subscribe(() => {
      this.updateFromState();
    });

    if (this.reservation === null) {
      //  THIS MAKES ALL THE CALLS TO APIS TO POPULATE STATE
      this._cancelRes.fetchReservation(this.reservationId, this.lastName, RouteNames.StayPreferences);
    }
  }

  updateFromState() {
    this.state = this._ngRedux.getState();
    if (!this.state) {
      return;
    }

    this.reservation = this.state.reservation;
    this.stayPreferences = this.state.stayPreferences;
    ActionHandler.handleError(this.state, AppAction.GET_RESERVATION, () => {
      this.error = this.state.error;
    });
    this.saveToProfile = this.state.saveToProfile;
    this.reservation = useDefault(this.state.reservation, null);
    this.hotel = this.state.hotel;
    this.stayPreferences = this.state.stayPreferences;
    if (this.state.member) {
      this.shouldDisplay = this.state.member.isExplicit();
    }
    ActionHandler.handleSuccess(
      this.state,
      AppAction.GET_STAY_PREFERENCES,
      () => {
        this.stayPreferences = this.state.stayPreferences;
      }
    );
  }


  onPrefChange(selection: string, message: string, id: string) {

    const tempStayPreferences = JSON.parse(JSON.stringify(this.stayPreferences));
    if (!!tempStayPreferences && !!tempStayPreferences.stayPreferences) {
      for (let i = 0; i < tempStayPreferences.stayPreferences.length; i++) {
        if (tempStayPreferences.stayPreferences[i].preferences) {
          for (let j = 0; j < tempStayPreferences.stayPreferences[i].preferences.length; j++) {
            if (selection === 'STRING') {
              if (id === tempStayPreferences.stayPreferences[i].preferences[j].id) {
                tempStayPreferences.stayPreferences[i].preferences[j].preferenceValue = message;
              }
            } else {
              for (let k = 0; k < tempStayPreferences.stayPreferences[i].preferences[j].options.length; k++) {
                switch (selection) {
                  case 'LIST':
                    if (id === tempStayPreferences.stayPreferences[i].preferences[j].id) {
                      tempStayPreferences.stayPreferences[i].preferences[j].options[k].selected = (tempStayPreferences.stayPreferences[i].preferences[j].options[k].id === message);
                    }
                    break;
                  case 'BOOLEAN':
                    if (id === tempStayPreferences.stayPreferences[i].preferences[j].id) {
                      if (tempStayPreferences.stayPreferences[i].preferences[j].options[k].id === 'true') {
                        tempStayPreferences.stayPreferences[i].preferences[j].options[k].selected = (message === 'true');
                      } else if (tempStayPreferences.stayPreferences[i].preferences[j].options[k].id === 'false') {
                        tempStayPreferences.stayPreferences[i].preferences[j].options[k].selected = (message !== 'true');
                      }
                    }
                    break;
                  default:
                    break;
                }
              }
            }
          }
        }
      }
      this._modifyReservationDelegate.editReservationStayPreferences(tempStayPreferences);
      this._modifyAccountDelegate.updateAccountStayPreferences(false, { key: id, value: message });
    }
  }

  // This method for debouncing toggling behavior was necessary due to a weird issue, possibly with angular 4, where the checkbox was calling
  // The toggle multiple times with invalid values.
  debounceToggling(container: number, shouldOverride: boolean) {
    if (this.debounceTime === 0) {
      this.onToggleTheOpenContainer(container, shouldOverride);
    }
    this.debounceTime = 1;
    // Set a timeout for 1 , afterwards change the debounce time back to 0

    const apiTimer = setInterval(() => {
      this.debounceTime = 0;
      clearInterval(apiTimer);
    }, (250));
  }

  onToggleTheOpenContainer(container: number, shouldOverride: boolean) {
    if (shouldOverride) {
      this.openContainer = container;
    }
  }

  onSaveToProfileChange(message: string) {
    this._actions.dispatchSaveToProfile(AppAction.SAVE_TO_PROFILE, (message === 'true'));
  }

  onSavePreferences() {
    if (this.saveToProfile) {
      this._modifyAccountDelegate.updateAccountStayPreferences(true, {});
    }
    this._modifyReservationDelegate.updateStayPrefernces(this.reservation);
  }

  formatName(name: string) {
    return name.replace(/\s|\/|\*|\(|\)/g, '');
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/stay-preference/stay-preference.component.ts